import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType } from '../../types/entity';
import { Pdf, IPdf } from './Pdf';
import { PdfTranslation, IPdfTranslation } from './PdfTranslation';
import { Section, ISection } from './Section';

export type IPdfSection = ISection & {
  attributes: {
    id: EntityStringId;
    downloadable: boolean;
  };
  associations: {
    masterPdf: IPdf;
    pdfTranslations: IPdfTranslation[];
    teacherPdf: IPdf;
  };
};

export type PdfSection = Entity<IPdfSection>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PdfSection: IEntityType<IPdfSection> = vmClient.defineClass({
  typeName: 'PdfSection',
  version: 8,
  lockable: true,
  persisted: true,
  extends: Section,
  attributes: {
    downloadable: {
      notNull: true,
      type: 'boolean',
    },
  },
  associations: {
    masterPdf: Pdf,
    pdfTranslations: [PdfTranslation],
    teacherPdf: Pdf,
  },
});
